import { createSelector } from 'reselect';

const reCaptchaSelector = state => state.reCaptcha;

export const isReCaptchaLoadedSelector = createSelector(
  reCaptchaSelector,
  (reCaptchaState): boolean => reCaptchaState.isLoaded
);
